<template>
  <main-layout :selectedMenu="'myHome'">
    <div class="container" @click.stop.prevent="isSearchShow = false">
      <asideCom :activityIndex="2"></asideCom>
      <div class="myRecurit">
        <div class="title">
          {{$t('recruit.招聘管理')}}
          <span>{{$t('recruit.有任何疑问可联系MANA小助手，微信号：')}}manamananet</span>
        </div>
        <div class="typeBox">
          <div
            :class="['type',type == 1? 'active': '']"
            @click="changeTab(1)"
          >{{$t('recruit.职位管理')}}</div>
          <div
            :class="['type',type == 2? 'active': '']"
            @click="changeTab(2)"
          >{{$t('recruit.公司信息')}}</div>
          <div
            :class="['type',type == 3? 'active': '']"
            @click="changeTab(3)"
          >{{$t('recruit.我的套餐')}}</div>
          <div class="submit" @click="submit">{{$t('recruit.发布新职位')}}</div>
          <div class="pay" @click="payMeal">{{$t('recruit.购买招聘套餐')}}</div>
        </div>
        <div class="box1" v-if="type == 1 && isShowBox">
          <div class="tips clearfix" v-for="(item,i) in overList" :key="i">
            {{$t('recruit.您的x已过期y天，不再享有套餐内的增益权益。',{x: item.comboName,y: Math.abs(item.remainDays)})}}
            <span
              @click="payMeal"
            >{{$t('recruit.购买招聘套餐')}} >></span>
            <i @click="closeTip(item.id)">x</i>
          </div>
          <div class="tips clearfix" v-for="(item,i) in willOverList" :key="i">
            {{$t('recruit.您的x将在a天后过期，还有z个职位未使用，过期后将不再享有增益权益。',{x: item.comboName,a: item.remainDays,z: item.remainCount})}}
            <span
              @click="payMeal"
            >{{$t('recruit.购买招聘套餐')}} >></span>
            <i @click="closeTip(item.id)">x</i>
          </div>
          <div class="statusBox">
            <span :class="status == 5 ? 'active':''" @click="changeType(5)">
              {{$t('recruit.全部')}}
              <i>{{allCount}}</i>
            </span>
            <span :class="status == 3 ? 'active':''" @click="changeType(3)">
              {{$t('recruit.在线')}}
              <i>{{upCount}}</i>
            </span>
            <span :class="status == 4 ? 'active':''" @click="changeType(4)">
              {{$t('recruit.已下线')}}
              <i>{{downCount}}</i>
            </span>
            <span :class="status == 1 ? 'active':''" @click="changeType(1)">
              {{$t('recruit.审核中')}}
              <i>{{pendingCount}}</i>
            </span>
            <span :class="status == 2 ? 'active':''" @click="changeType(2)">
              {{$t('recruit.审核不通过')}}
              <i>{{refuseCount}}</i>
            </span>
            <div class="searchBox">
              <img src="https://image.manamana.net/1615974397000_hAuwXbGu" alt />
              <input :placeholder="$t('recruit.搜索职位名称/城市')" type="text" v-model="keyword" />
            </div>
          </div>
          <div class="formBox" v-if="list.length">
            <div class="tab clearfix">
              <span class="tab1">{{$t('recruit.职位')}}</span>
              <span class="tab2">{{$t('recruit.发布日期')}}</span>
              <span class="tab3">{{$t('recruit.状态')}}</span>
              <span class="tab4">{{$t('recruit.操作')}}</span>
            </div>
            <div class="listBox">
              <div class="list clearfix" v-for="(item,i) in list" :key="i">
                <div class="jobs">
                  <div class="name" @click="gotoDetail(item)">{{item.positionName}}</div>
                  <div
                    class="info"
                  >{{item.negotiable==1?$t('recruit.面议'):item.salaryBegin+'K-'+item.salaryEnd+"K"}} | {{getExperience(item.experience)}} | {{getEducation(item.education)}} | {{item.cityName}}</div>
                </div>
                <div class="time">{{item.updateTime | formatDate("YYYY-MM-DD")}}</div>
                <div
                  :class="['status',item.status == 1 ? 'padding': item.status == 2?'noPass':'']"
                  >
                  {{getStatus(item.status)}}
                  <el-popover
                    placement="right"
                    trigger="hover"
                    :disabled="item.status != 2"
                  >
                    <div class="raesonText">{{ item.reason }}</div>
                    <img
                      v-if="item.status == 2"
                      slot="reference"
                      src="https://image.manamana.net/1615974600000_gZzzoSHT"
                      alt=""
                    />
                  </el-popover>
                </div>
                <div class="caozuo">
                  <span @click="edit(item.id)">{{$t('recruit.编辑')}}</span>
                  <span
                    v-if="!(item.status == 1 || item.status == 2)"
                    @click="updownStatus(item)"
                  >{{item.status == 3 ? $t('recruit.下线'):$t('recruit.上线')}}</span>
                  <span
                    @click="deleteDetail(item.id)"
                    v-if="(item.status == 1 || item.status == 2)"
                  >{{$t('recruit.删除')}}</span>
                </div>
              </div>
            </div>
            <pagination
              :totalRecord="totalRecord"
              :pageSize="pageSize"
              :pageIndex="pageIndex"
              @OnCurrentChanged="changePage"
            />
          </div>
          <div v-else class="noData">
            <img src="https://image.manamana.net/1652689253000_undefinedfrQwDwR" alt />
            <p>{{$t('global.暂无数据')}}</p>
          </div>
        </div>
        <div class="box2" v-if="type == 2">
          <div class="jobsInfoBox">
            <div class="title">
              <i>*</i>
              {{$t('recruit.公司介绍')}}
              <span
                v-if="companyInfo"
                @click="addCompanyInfo"
              >{{$t('recruit.编辑')}}</span>
            </div>
            <div class="addInfo" v-if="!companyInfo" @click="addCompanyInfo">
              <img src="https://image.manamana.net/1652859821000_yFFpNiwt" alt />
              <p>+ {{$t('recruit.添加公司介绍')}}</p>
            </div>
            <div class="info" v-if="companyInfo" v-html="getHtml(companyInfo)"></div>
          </div>
          <div class="jobsImgsBox">
            <div class="imgTitle">
              {{$t('recruit.公司相册')}}
              <span>{{$t('recruit.选填，最多10张')}}</span>
            </div>
            <div class="imgBox clearfix">
              <div
                class="deteImgBox"
                v-for="(item,i) in companyPhoto"
                :key="i"
                @mouseenter="index=i"
                @mouseleave="index=null"
                v-if="companyPhoto.length"
              >
                <span v-if="index === i" @click="detePhoto(i)">{{$t('recruit.删除')}}</span>
                <img class="imgBa" :src="item | imageUrl('',480,270)" alt />
                <div class="backG" v-if="index === i"></div>
              </div>
              <div class="addImg" @click="addPhoto" v-if="companyPhoto.length < 10">
                <img src="https://image.manamana.net/1652860348000_xDcItYlW" alt />
                <p class="title1">+ {{$t('recruit.添加公司相册')}}</p>
                <p class="title2">{{$t('recruit.图片大小不超过10M')}}</p>
              </div>
            </div>
          </div>
          <div class="anliBox">
            <div class="anli">
              {{$t('recruit.项目案例')}}
              <span>{{$t('recruit.选填，最多3个')}}</span>
              <i v-if="caseVideo.length || caseImage.length" @click="addAnli">{{$t('recruit.编辑')}}</i>
            </div>
            <div class="addAnli" @click="addAnli" v-if="!caseVideo.length && !caseImage.length">
              <img src="https://image.manamana.net/1652861112000_dOfiSttp" alt />
              <p class="title1">+ {{$t('recruit.添加项目案例')}}</p>
            </div>
            <div class="videoBox clearfix" v-if="caseVideo.length">
              <div
                class="infoBox"
                v-for="(item,i) in caseVideo"
                :key="i"
                @click="gotoVideo(item.path)"
              >
                <div class="imgBox1">
                  <img class="img1" :src="item.url | imageUrl('',510,288)" alt />
                  <img class="img2" src="https://image.manamana.net/1646382130000_NiFGwnwC" alt />
                </div>
                <p class="name">{{item.title}}</p>
              </div>
            </div>
            <div class="videoBox clearfix" v-if="caseImage.length">
              <div class="infoBox" v-for="(item,i) in caseImage" :key="i">
                <div class="imgBox1">
                  <img class="img1" :src="item.path | imageUrl('',510,288)" alt />
                </div>
                <p class="name">{{item.title}}</p>
              </div>
            </div>
            <div
              class="textTitle"
              v-if="!caseVideo.length && !caseImage.length"
            ></div>
          </div>
        </div>
        <div class="box3" v-if="type == 3">
          <div class="formBox" v-if="comboList.length">
            <div class="tab clearfix">
              <span class="tab1">{{$t('recruit.套餐')}}</span>
              <span class="tab2">{{$t('recruit.总价')}}</span>
              <span class="tab3">{{$t('recruit.有效期')}}</span>
              <span class="tab4">{{$t('recruit.状态')}}</span>
              <span class="tab5">{{$t('recruit.职位数')}}</span>
              <span class="tab6">{{$t('recruit.剩余职位数')}}（{{getCountAll()}}）</span>
            </div>
            <div class="listBox">
              <div class="list clearfix" v-for="(item,i) in comboList" :key="i">
                <span class="tab1">{{item.comboName}}</span>
                <span class="tab2">￥{{item.money}}</span>
                <span
                  class="tab3"
                >{{item.beginIndate | formatDate("YYYY.MM.DD")}} - {{item.endIndate | formatDate("YYYY.MM.DD")}}</span>
                <span
                  :class="[item.isExpired == 1?'tab4':'tab5']"
                >{{item.isExpired == 1? $t('recruit.使用中') : $t('recruit.已过期')}}</span>
                <span class="tab5">{{item.isLimit == 1? $t('recruit.无限制'):item.recruitCount}}</span>
                <span
                  class="tab6"
                >{{item.isExpired == 1?item.isLimit == 1? $t('recruit.无限制'): item.remainCount:'-'}}</span>
              </div>
            </div>
          </div>
          <div v-else class="noData">
            <img src="https://image.manamana.net/1652689253000_undefinedfrQwDwR" alt />
            <p>{{$t('global.暂无数据')}}</p>
          </div>
        </div>
      </div>
      <div class="popBox" v-if="isShowPop">
        <div class="box">
          <div class="title">
            {{popTitle}}
            <span @click="close"></span>
          </div>
          <div class="info">{{popInfo}}</div>
          <div class="but" v-if="popBut1 == ''">
            <span @click="but">{{popBut}}</span>
          </div>
          <div class="but1" v-else>
            <span @click="but" class="span1">{{popBut}}</span>
            <span @click="butnext" class="span2">{{popBut1}}</span>
          </div>
        </div>
      </div>
      <div class="popBox" v-if="isShowPop1">
        <div class="box box1">
          <div class="title">
            {{$t('recruit.编辑公司介绍')}}
            <span @click="close1"></span>
          </div>
          <div class="info1">
            <el-input
              type="textarea"
              :placeholder="$t('recruit.请输入内容')"
              v-model="info"
              maxlength="1000"
              show-word-limit
              style="width: 760px;height: 174px;"
            ></el-input>
          </div>
          <div class="but">
            <span @click="but1">{{$t('recruit.提交')}}</span>
          </div>
        </div>
      </div>
      <div class="popBox" v-if="isShowPop2">
        <div class="box2">
          <div class="title">
            {{$t('recruit.请选择项目案例')}}
            <i>{{$t('recruit.最多3个')}}</i>
            <span @click="close2"></span>
          </div>
          <div class="typeBox1">
            <span :class="anliType == 1? 'active':''" @click="anliType=1">{{$t('recruit.视频形式')}}</span>
            <span :class="anliType == 2? 'active':''" @click="anliType=2">{{$t('recruit.图片形式')}}</span>
          </div>
          <div class="videoBox" v-if="anliType == 1">
            <div class="clearfix" v-if="videoList.length">
              <div class="video" v-for="(item,i) in videoList" :key="i">
                <div class="imgBox">
                  <img class="img1" :src="item.thumb | imageUrl('',460,260)" alt />
                  <span>{{getVideoIndex(item.id)}}</span>
                  <img
                    class="img2"
                    @click="changeVideo(item)"
                    v-if="getVideoIndex(item.id)"
                    src="https://image.manamana.net/1650432245000_NWqnHAXW"
                    alt
                  />
                  <i @click="changeVideo(item)" v-else></i>
                  <div class="bg"></div>
                </div>
                <div class="videoTitle">{{item.title}}</div>
              </div>
            </div>
            <div v-else class="noData1">
              <p>{{$t('recruit.您尚未上传任何项目案例视频，发布后即可添加！')}}</p>
              <div class="but" @click="gotoUploadVideo">{{$t('recruit.去上传')}}</div>
            </div>
            <pagination
              :totalRecord="totalRecord1"
              :pageSize="pageSize1"
              :pageIndex="pageIndex1"
              @OnCurrentChanged="changePage1"
            />
          </div>
          <div class="photoBox clearfix" v-if="anliType == 2">
            <div class="photTitle">{{$t('recruit.拖拽可调整排序')}}</div>
            <div class="photoBox1 clearfix">
              <draggable
                v-model="selectImgList"
                chosenClass="chosen"
                forceFallback="true"
                group="people"
                animation="500"
              >
                <div class="photo" v-for="(item,i) in selectImgList" :key="i">
                  <div class="imgBox" @mouseenter="anliIndex=i" @mouseleave="anliIndex=null">
                    <img class="img1" :src="item.path | imageUrl('',460,260)" alt />
                    <img
                      class="img2"
                      src="https://image.manamana.net/1652861991000_fDUKmqAA"
                      alt
                      v-if="anliIndex === i"
                      @click="detePhoto1(i)"
                    />
                    <div class="backG" v-if="anliIndex === i"></div>
                  </div>
                  <div class="photTitle1">
                    <el-input
                      type="textarea"
                      :placeholder="$t('recruit.添加标题')"
                      v-model="item.title"
                      maxlength="30"
                      show-word-limit
                      style="width: 230px;height: 52px;"
                    ></el-input>
                  </div>
                </div>
              </draggable>
              <div class="upImg" v-if="selectImgList.length < 3" @click="uploadImg">
                <img src="https://image.manamana.net/1652860348000_xDcItYlW" alt />
                <p class="title1">+ 添加照片</p>
                <p class="title2">图片大小不超过10M</p>
              </div>
            </div>
          </div>
          <div class="but" v-if="!(anliType == 1&&!videoList.length)">
            <span @click="submitAnli">{{$t('recruit.提交')}}</span>
          </div>
        </div>
      </div>
    </div>
    <input
      type="file"
      class="upInputIMG"
      accept="image/*"
      @change="upImg"
    />
    <input
      type="file"
      class="upInputIMG1"
      accept="image/*"
      @change="upImg1"
    />
  </main-layout>
</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout";
import asideCom from "@/components/aside.vue";
import Pagination from "@/components/v2/Pagination";
import * as qiniu from "qiniu-js";
import draggable from "vuedraggable";
export default {
  name: "manageVideo",
  metaInfo() {
    return {
      title: "招聘管理 | MANA"
    };
  },
  data() {
    return {
      type: 1,
      keyword: "",
      status: 5,
      index: null,
      isShowPop: false,
      isShowPop1: false,
      isShowPop2: false,
      popTitle: "",
      popInfo: "",
      popBut: "",
      popBut1: "",
      popType: 1,
      companyInfo: "",
      companyPhoto: [],
      caseVideo: [],
      caseImage: [],
      info: "",
      anliType: 1,
      pageIndex: 1,
      pageIndex1: 1,
      pageSize: 5,
      pageSize1: 6,
      videoList: [],
      videoIndex: 1,
      selectVideoList: [],
      imgList: [],
      selectImgList: [],
      anliIndex: null,
      allCount: 0,
      downCount: 0,
      pendingCount: 0,
      refuseCount: 0,
      upCount: 0,
      list: [],
      totalRecord: 0,
      totalRecord1: 0,
      comboList: [],
      infoItem: {},
      overList: [],
      willOverList: [],
      isShowBox: false,
      hasNextPage: false
    };
  },
  components: {
    MainLayout,
    asideCom,
    Pagination,
    draggable
  },
  created() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    if (this.$route.query.click) {
      this.submit();
    }
    this.getInfo();
    this.getList();
    this.getCount();
    this.getTip();
  },
  computed: {
    peopleMessage() {
      return this.$store.state.peopleMessage;
    },
    language() {
      return this.$language();
    }
  },
  destroyed() {
    document.body.style.overflow = "";
  },
  methods: {
    getCountAll() {
      let num = 0;
      if (this.comboList.length) {
        for (let i = 0; i < this.comboList.length; i++) {
          if (
            this.comboList[i].isExpired == 1 &&
            this.comboList[i].isLimit == 1
          ) {
            return this.$t("recruit.无限制");
          } else if (this.comboList[i].isExpired == 1) {
            num += this.comboList[i].remainCount;
          }
        }
        return num;
      } else {
        return 0;
      }
    },
    getHtml(text) {
      let value = "";
      if (text) {
        value = text.replace(/(\r\n|\n|\r)/gm, "<br />");
      }
      return value;
    },
    gotoDetail(item) {
      if (item.status == 3) {
        let routeData = this.$router.resolve({
          path: "/recruitDetail/" + item.id
        });
        window.open(routeData.href, "_blank");
      }
    },
    gotoUploadVideo() {
      let routeData = this.$router.resolve({
        path: "/UpVideo"
      });
      window.open(routeData.href, "_blank");
    },
    changeTab(i) {
      this.type = i;
      this.$router.push({
        path: "/MyRecruit",
        query: {
          type: i
        }
      });
    },
    closeTip(id) {
      this.$http.get("/api/u/recruit/combo/tip/close/" + id).then(res => {
        if (res.code == "OK") {
          this.getTip();
        }
      });
    },
    getTip() {
      this.$http.get("/api/u/recruit/combo/tip").then(res => {
        if (res.code == "OK") {
          this.overList = res.data.over;
          this.willOverList = res.data.willOver;
        }
      });
    },
    getComboList() {
      this.$http.get("/api/u/recruit/combo/all").then(res => {
        if (res.code == "OK") {
          this.comboList = res.data;
        }
      });
    },
    payMeal() {
      this.$router.push("/payMeal/home");
    },
    changeType(i) {
      this.status = i;
      this.getList();
    },
    deleteDetail(id) {
      var $this = this;
      this.$confirm(
        this.$t("recruit.是否删除该职位？"),
        this.$t("recruit.提示"),
        {
          confirmButtonText: this.$t("global.确定"),
          cancelButtonText: this.$t("global.取消"),
          type: "warning"
        }
      )
        .then(() => {
          $this.$http.delete("/api/u/recruit/info/" + id).then(res => {
            if (res.code == "OK") {
              this.$message.success(this.$t("recruit.删除成功！"));
              this.getList();
              this.getCount();
            }
          });
        })
        .catch(() => {});
    },
    edit(id) {
      this.$router.push("/releasePosition?id=" + id);
    },
    getStatus(i) {
      if (i == 1) {
        return this.$t("recruit.审核中");
      }
      if (i == 2) {
        return this.$t("recruit.未通过");
      }
      if (i == 3) {
        return this.$t("recruit.在线");
      }
      if (i == 4) {
        return this.$t("recruit.已下线");
      }
    },
    getExperience(i) {
      if (i == 1) {
        return this.$t("recruit.不限");
      }
      if (i == 2) {
        return this.$t("recruit.1年以下");
      }
      if (i == 3) {
        return this.$t("recruit.1-3年");
      }
      if (i == 4) {
        return this.$t("recruit.3-5年");
      }
      if (i == 5) {
        return this.$t("recruit.5-10年");
      }
      if (i == 6) {
        return this.$t("recruit.10年以上");
      }
    },
    getEducation(i) {
      if (i == 1) {
        return this.$t("recruit.不限");
      }
      if (i == 2) {
        return this.$t("recruit.大专");
      }
      if (i == 3) {
        return this.$t("recruit.本科");
      }
      if (i == 4) {
        return this.$t("recruit.硕士");
      }
      if (i == 5) {
        return this.$t("recruit.博士");
      }
    },
    getCount() {
      this.$http.get("/api/u/recruit/info/status/count").then(res => {
        if (res.code == "OK") {
          this.allCount = res.data.allCount;
          this.downCount = res.data.downCount;
          this.pendingCount = res.data.pendingCount;
          this.refuseCount = res.data.refuseCount;
          this.upCount = res.data.upCount;
        }
      });
    },
    getList() {
      let params = {
        status: this.status,
        keyword: this.keyword,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      this.$http.get("/api/u/recruit/info/", { params }).then(res => {
        if (res.code == "OK") {
          this.list = res.data.list;
          this.totalRecord = res.data.totalRecord;
          this.isShowBox = true;
        }
      });
    },
    changePage(index) {
      this.pageIndex = index;
      this.getList();
    },
    changePage1(index) {
      this.pageIndex1 = index;
      this.getVideoList();
    },
    gotoVideo(id) {
      let routeData = this.$router.resolve({
        path: "/video/detail?id=" + id
      });
      window.open(routeData.href, "_blank");
    },
    getVideoIndex(id) {
      let index = this.selectVideoList.findIndex(val => val["path"] === id);
      if (this.selectVideoList.findIndex(val => val["path"] === id) !== -1) {
        return index + 1;
      }
    },
    uploadImg() {
      document.querySelector(".upInputIMG1").click();
    },
    changeVideo(item) {
      if (this.selectVideoList.length) {
        let index = this.selectVideoList.findIndex(
          val => val["path"] === item["id"]
        );
        if (index !== -1) {
          this.selectVideoList.splice(index, 1);
        } else {
          if (this.selectVideoList.length >= 3) {
            this.$message.error(this.$t("recruit.最多添加3个案例！"));
            return;
          }
          this.selectVideoList.push({
            title: item.title,
            path: item.id,
            url: item.thumb
          });
        }
      } else {
        this.selectVideoList.push({
          title: item.title,
          path: item.id,
          url: item.thumb
        });
      }
    },
    submitAnli() {
      var url = "";
      var params = null;
      if (this.anliType == 1) {
        if (!this.selectVideoList.length) {
          this.$message.error(this.$t("recruit.请选择案例！"));
          return;
        }
        url = "/api/u/recruit/company/case/video";
        params = {
          caseVideo: JSON.stringify(this.selectVideoList)
        };
      }
      if (this.anliType == 2) {
        if (!this.selectImgList.length) {
          this.$message.error(this.$t("recruit.请选择案例！"));
          return;
        }
        url = "/api/u/recruit/company/case/image";
        params = {
          caseImage: JSON.stringify(this.selectImgList)
        };
      }
      this.$http.post(url, params).then(res => {
        if (res.code == "OK") {
          this.getInfo();
          this.close2();
        }
      });
    },
    addAnli() {
      this.getVideoList();
    },
    getVideoList() {
      var params = {
        userId: this.peopleMessage.userId,
        order: 0,
        pageIndex: this.pageIndex1,
        pageSize: 6
      };
      this.$http.get("/api/mobile/2.0/u/getVideoList", { params }).then(res => {
        if (res.code == "OK") {
          if (res.data && res.data.list) {
            this.videoList = res.data.list;
            this.totalRecord1 = res.data.totalRecord;
          }
          if (this.selectImgList.length) {
            this.anliType = 2;
          }
          if (this.selectVideoList.length) {
            this.anliType = 1;
          }
          document.body.style.overflow = "hidden";
          this.isShowPop2 = true;
        }
      });
    },
    close2() {
      document.body.style.overflow = "";
      this.isShowPop2 = false;
    },
    addPhoto() {
      document.querySelector(".upInputIMG").value = "";
      document.querySelector(".upInputIMG").click();
    },
    detePhoto(index) {
      this.companyPhoto = this.companyPhoto.filter((item, i) => {
        return i != index;
      });
      var params = {
        companyPhoto: this.companyPhoto.join(",")
      };
      this.$http.post("/api/u/recruit/company/photo", params).then(res => {});
    },
    detePhoto1(index) {
      this.selectImgList = this.selectImgList.filter((item, i) => {
        return i != index;
      });
    },
    upImg(e) {
      let $this = this;
      if (e.target.files[0].size / 1024 / 1024 > 10) {
        this.$message.error(`${this.$t("global.上传图片大小不能超过")} 10MB!`);
        return;
      }
      var observable;
      var subscription;
      var error = function(err) {
        $this.$message.error($this.$t("global.上传失败"));
      };
      var complete = function(res) {
        $this.$message.success($this.$t("global.上传成功"));
        $this.companyPhoto.push(res.key);
        var params = {
          companyPhoto: $this.companyPhoto.join(",")
        };
        $this.$http
          .post("/api/u/recruit/company/photo", params)
          .then(res => {});
      };

      var next = function(response) {};

      var subObject = {
        next: next,
        error: error,
        complete: complete
      };

      var config = {
        useCdnDomain: true,
        region: null,
        domain: "https://image.manamana.net",
        forceDirect: true
      };
      var putExtra = {
        fname: e.target.files[0].name,
        params: {},
        mimeType: null
      };
      this.$http.get("/api/common/upload/image/token").then(res => {
        observable = qiniu.upload(
          e.target.files[0],
          Date.parse(new Date()) + "_" + this.$jsonUtils.randomLetter(8),
          res.message,
          putExtra,
          config
        );
        subscription = observable.subscribe(subObject);
      });
    },
    upImg1(e) {
      let $this = this;
      if (e.target.files[0].size / 1024 / 1024 > 10) {
        this.$message.error(`${this.$t("global.上传图片大小不能超过")} 10MB!`);
        return;
      }
      var observable;
      var subscription;
      var error = function(err) {
        $this.$message.error($this.$t("global.上传失败"));
      };
      var complete = function(res) {
        $this.$message.success($this.$t("global.上传成功"));
        $this.selectImgList.push({
          path: res.key,
          title: ""
        });
      };

      var next = function(response) {};

      var subObject = {
        next: next,
        error: error,
        complete: complete
      };

      var config = {
        useCdnDomain: true,
        region: null,
        domain: "https://image.manamana.net",
        forceDirect: true
      };
      var putExtra = {
        fname: e.target.files[0].name,
        params: {},
        mimeType: null
      };
      this.$http.get("/api/common/upload/image/token").then(res => {
        observable = qiniu.upload(
          e.target.files[0],
          Date.parse(new Date()) + "_" + this.$jsonUtils.randomLetter(8),
          res.message,
          putExtra,
          config
        );
        subscription = observable.subscribe(subObject);
      });
    },
    getInfo() {
      this.$http.get("/api/u/recruit/company/info").then(res => {
        if (res.code == "OK") {
          if (res.data) {
            this.companyInfo = res.data.companyInfo;
            if (res.data.companyPhoto) {
              this.companyPhoto = res.data.companyPhoto.split(",");
            }
            if (res.data.caseVideo) {
              this.caseVideo = JSON.parse(res.data.caseVideo);
              for (let i = 0; i < this.caseVideo.length; i++) {
                this.selectVideoList.push({
                  title: this.caseVideo[i].title,
                  path: this.caseVideo[i].path,
                  url: this.caseVideo[i].url
                });
              }
            } else {
              this.caseVideo = [];
              this.selectVideoList = [];
            }
            if (res.data.caseImage) {
              this.caseImage = JSON.parse(res.data.caseImage);
              this.selectImgList = JSON.parse(res.data.caseImage);
            } else {
              this.caseImage = [];
              this.selectImgList = [];
            }
          }
        }
      });
    },
    addCompanyInfo() {
      document.body.style.overflow = "hidden";
      this.isShowPop1 = true;
      this.info = this.companyInfo;
    },
    close() {
      document.body.style.overflow = "";
      this.isShowPop = false;
    },
    but() {
      if (this.popType == 1 || this.popType == 6) {
        this.close();
      }
      if (this.popType == 2) {
        this.close();
        this.type = 2;
      }
      if (this.popType == 3) {
        this.close();
        this.$router.push("/ApplyIdentification?type=1");
      }
      if (this.popType == 4) {
        this.close();
        this.$router.push("/payMeal/home");
      }
      if (this.popType == 5) {
        this.close();
        this.type = 3;
      }
    },
    butnext() {
      if (this.popType == 4) {
        this.close();
        this.$router.push("/releasePosition");
      }
      if (this.popType == 5) {
        this.close();
        this.$router.push("/payMeal/home");
      }
      if (this.popType == 6) {
        this.close();
        this.changeStatus();
      }
    },
    changeStatus() {
      this.$http
        .get("/api/u/recruit/info/updown/" + this.infoItem.id)
        .then(res => {
          if (res.code == "OK") {
            this.$message.success(this.$t("recruit.修改成功！"));
            this.getList();
          }
        });
    },
    but1() {
      if (!this.info) {
        this.$message.error(this.$t("recruit.请输入公司简介！"));
      }
      var params = {
        companyInfo: this.info
      };
      this.$http
        .post("/api/u/recruit/company/info", params, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          if (res.code == "OK") {
            document.body.style.overflow = "";
            this.isShowPop1 = false;
            this.getInfo();
          }
        });
    },
    close1() {
      document.body.style.overflow = "";
      this.isShowPop1 = false;
    },
    submit() {
      this.$http.get("/api/u/recruit/company/status/pc").then(res => {
        if (res.code == "OK") {
          if (res.data.companyCertificationStatus == 1) {
            if (res.data.isClickBtn) {
              if (res.data.companyInfoStatus == 1) {
                if (res.data.isInRecruit) {
                  if (res.data.remainCount !== 0) {
                    this.$router.push("/releasePosition");
                  } else {
                    this.$http.get("/api/u/recruit/combo/current").then(res => {
                      if (res.data) {
                        this.popTitle = this.$t("recruit.发布职位");
                        this.popInfo = this.$t(
                          "recruit.您套餐内的职位数已用完，要发布更多职位请升级招聘套餐或购买职位数。"
                        );
                        this.popBut = this.$t("recruit.查看我的套餐");
                        this.popBut1 = this.$t("recruit.购买套餐");
                        this.popType = 5;
                        document.body.style.overflow = "hidden";
                        this.isShowPop = true;
                      } else {
                        this.popTitle = this.$t("recruit.发布职位");
                        this.popInfo = this.$t(
                          "recruit.您正在使用招聘套餐免费版，每年可免费发布5个职位。要发布更多职位请升级招聘套餐或购买职位数"
                        );
                        this.popBut = this.$t("recruit.了解套餐详情");
                        this.popBut1 = this.$t("recruit.继续发布");
                        this.popType = 4;
                        document.body.style.overflow = "hidden";
                        this.isShowPop = true;
                      }
                    });
                  }
                } else {
                  this.popTitle = this.$t("recruit.发布职位");
                  this.popInfo = this.$t(
                    "recruit.您正在使用招聘套餐免费版，每年可免费发布5个职位。要发布更多职位请升级招聘套餐或购买职位数"
                  );
                  this.popBut = this.$t("recruit.了解套餐详情");
                  this.popBut1 = this.$t("recruit.继续发布");
                  this.popType = 4;
                  document.body.style.overflow = "hidden";
                  this.isShowPop = true;
                }
              } else if (res.data.companyInfoStatus == 2) {
                this.popTitle = this.$t("recruit.完善公司信息");
                this.popInfo = this.$t(
                  "recruit.请先完善公司信息，完善后即可发布职位！"
                );
                this.popBut = this.$t("recruit.去完善");
                this.popType = 2;
                document.body.style.overflow = "hidden";
                this.isShowPop = true;
              }
            } else {
              this.popTitle = this.$t("recruit.完善公司信息");
              this.popInfo = this.$t(
                "recruit.请先完善公司信息，完善后即可发布职位！"
              );
              this.popBut = this.$t("recruit.去完善");
              this.popType = 2;
              document.body.style.overflow = "hidden";
              this.isShowPop = true;
            }
          }
          if (res.data.companyCertificationStatus == 2) {
            this.popTitle = this.$t("recruit.企业认证");
            this.popInfo = this.$t(
              "recruit.您的企业认证信息正在审核中，审核通过后即可发布职位信息，请耐心等待"
            );
            this.popBut = this.$t("recruit.确定");
            this.popType = 1;
            document.body.style.overflow = "hidden";
            this.isShowPop = true;
          }
          if (res.data.companyCertificationStatus == 3) {
            this.popTitle = this.$t("recruit.企业认证");
            this.popInfo = this.$t(
              "recruit.请先进行企业认证，认证通过后即可发布招聘信息"
            );
            this.popBut = this.$t("recruit.去认证");
            this.popType = 3;
            document.body.style.overflow = "hidden";
            this.isShowPop = true;
          }
          if (res.data.companyCertificationStatus == 4) {
            this.popTitle = this.$t("recruit.企业认证");
            this.popInfo = this.$t(
              "recruit.您的企业认证信息未通过，请联系客服"
            );
            this.popBut = this.$t("recruit.确定");
            this.popType = 1;
            document.body.style.overflow = "hidden";
            this.isShowPop = true;
          }
        }
      });
    },
    updownStatus(item) {
      if (item.status == 3) {
        this.popTitle = this.$t("recruit.下线职位");
        this.popInfo = this.$t(
          "recruit.职位下线后再次上线时将消耗套餐内的1个职位数，确认下线？"
        );
        this.popBut = this.$t("recruit.取消");
        this.popBut1 = this.$t("recruit.下线该职位");
        this.popType = 6;
        this.infoItem = item;
        document.body.style.overflow = "hidden";
        this.isShowPop = true;
      }
      if (item.status == 4) {
        this.$http.get("/api/u/recruit/combo/current").then(res => {
          if (res.data) {
            if (res.data.remainCount != 0) {
              this.popTitle = this.$t("recruit.上线职位");
              this.popInfo = this.$t(
                "recruit.上线职位将消耗套餐内的1个职位数，请知晓！"
              );
              this.popBut = this.$t("recruit.取消");
              this.popBut1 = this.$t("recruit.上线该职位");
              this.popType = 6;
              this.infoItem = item;
              document.body.style.overflow = "hidden";
              this.isShowPop = true;
            } else {
              this.popTitle = this.$t("recruit.上线职位");
              this.popInfo = this.$t(
                "recruit.您套餐内的职位数已用完，要发布更多职位请升级招聘套餐或购买职位数。"
              );
              this.popBut = this.$t("recruit.查看我的套餐");
              this.popBut1 = this.$t("recruit.购买套餐");
              this.popType = 5;
              document.body.style.overflow = "hidden";
              this.isShowPop = true;
            }
          } else {
            this.popTitle = this.$t("recruit.上线职位");
            this.popInfo = this.$t(
              "recruit.您正在使用招聘套餐免费版，每年可免费发布5个职位。要发布更多职位请升级招聘套餐或购买职位数"
            );
            this.popBut = this.$t("recruit.取消");
            this.popBut1 = this.$t("recruit.上线该职位");
            this.popType = 6;
            this.infoItem = item;
            document.body.style.overflow = "hidden";
            this.isShowPop = true;
          }
        });
      }
    }
  },
  watch: {
    keyword(val) {
      if (val) {
        this.keyword = val;
        this.getList();
      } else {
        this.getList();
      }
    },
    type(val) {
      if (val == 3) {
        this.getComboList();
      }
    }
  }
};
</script>
<style>
.info1 .el-textarea__inner {
  height: 174px !important;
  border-radius: 0;
  border: none;
  line-height: 21px;
  resize: none;
  padding: 24px 30px;
}
.photTitle1 .el-textarea__inner {
  height: 52px !important;
  line-height: 26px;
  border-radius: 0;
  resize: none;
}
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.body {
  background: #FAFAFA;
}

.container {
  width: 1110px;
  padding: 40px 0 120px 0;
  display: flex;
  margin: 0 auto;
  background: #FAFAFA;

  .myRecurit {
    width: 825px;
    padding-top: 16px;

    .title {
      height: 30px;
      font-size: 20px;
      font-weight: 600;
      color: #333333;
      line-height: 30px;
      margin-bottom: 14px;

      span {
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        margin-left: 8px;
        line-height: 30px;
      }
    }

    .typeBox {
      height: 52px;
      line-height: 52px;
      position: relative;
      border-bottom: 1px solid #EBEBEB;

      .type {
        display: inline-block;
        height: 52px;
        line-height: 52px;
        font-size: 16px;
        font-weight: 400;
        color: #999999;
        margin-right: 36px;
        cursor: pointer;
      }

      .active {
        border-bottom: 2px solid #333;
        font-weight: 600;
        color: #333333;
        box-sizing: border-box;
      }

      .submit {
        position: absolute;
        right: 0;
        bottom: 8px;
        width: 104px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background: #2026CC;
        font-size: 14px;
        font-weight: 600;
        color: #FFFFFF;
        cursor: pointer;
      }

      .pay {
        position: absolute;
        right: 124px;
        height: 20px;
        bottom: 16px;
        font-size: 14px;
        font-weight: 400;
        color: #2026CC;
        line-height: 20px;
        cursor: pointer;
      }
    }

    .box1 {
      padding-top: 20px;

      .tips {
        padding-left: 10px;
        height: 44px;
        line-height: 44px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        background: rgba(255, 196, 0, 0.2);
        margin-bottom: 20px;

        span {
          color: #2026CC;
          cursor: pointer;
        }

        i {
          color: #424242;
          float: right;
          width: 28px;
          line-height: 44px;
          text-align: center;
          cursor: pointer;
        }
      }

      .statusBox {
        height: 70px;
        line-height: 70px;
        position: relative;

        span {
          display: inline-block;
          padding: 0 15px;
          height: 30px;
          line-height: 28px;
          border-radius: 18px;
          border: 1px solid #2026CC;
          font-size: 12px;
          font-weight: 600;
          color: #2026CC;
          margin-right: 20px;
          box-sizing: border-box;
          cursor: pointer;

          i {
            margin-left: 5px;
          }
        }

        span.active {
          background: #2026CC;
          color: #FFFFFF;
          line-height: 30px;
        }

        .searchBox {
          width: 250px;
          height: 36px;
          line-height: 36px;
          box-sizing: border-box;
          background: #FFFFFF;
          border: 1px solid #E0E0E0;
          padding-left: 12px;
          position: absolute;
          right: 0;
          bottom: 18px;

          img {
            width: 16px;
            height: 16px;
          }

          input {
            width: 200px;
            height: 30px;
            line-height: 30px;
            border: none;
          }
        }
      }

      .formBox {
        width: 100%;
        height: 792px;
        box-sizing: border-box;
        background: #FFFFFF;
        border: 1px solid #E0E0E0;

        .tab {
          height: 40px;
          line-height: 40px;
          background: #F5F5F5;
          font-size: 13px;
          font-weight: 400;
          color: #999999;

          .tab1 {
            float: left;
            padding-left: 20px;
            width: 288px;
          }

          .tab2 {
            float: left;
            width: 226px;
            text-align: center;
          }

          .tab3 {
            float: left;
            width: 132px;
          }

          .tab4 {
            float: left;
            width: 155px;
          }
        }

        .listBox {
          height: 415px;
          margin-bottom: 165px;

          .list {
            height: 82px;
            line-height: 82px;
            border-top: 1px solid #EBEBEB;

            .jobs {
              float: left;
              padding-left: 20px;
              width: 288px;

              .name {
                height: 20px;
                font-size: 13px;
                font-weight: 600;
                color: #333333;
                line-height: 20px;
                margin-bottom: 5px;
                padding-top: 20px;
                cursor: pointer;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .info {
                height: 17px;
                font-size: 12px;
                font-weight: 400;
                color: #999999;
                line-height: 17px;
              }
            }

            .time {
              float: left;
              width: 226px;
              text-align: center;
              font-size: 12px;
              font-weight: 400;
              color: #999999;
            }

            .status {
              float: left;
              width: 132px;
              font-size: 12px;
              font-weight: 400;
              img{
                width: 14px;
                height: 14px;
                vertical-align: sub;
                cursor: pointer;
              }
            }

            .padding {
              color: #FFC400;
            }

            .noPass {
              color: #FE5630;
            }

            .caozuo {
              float: left;
              width: 155px;
              font-size: 12px;
              font-weight: 400;
              color: #3664ED;

              span {
                margin-right: 16px;
                cursor: pointer;
              }
            }
          }
        }
      }

      .noData {
        text-align: center;
        width: 100%;
        height: 792px;
        box-sizing: border-box;
        background: #FFFFFF;
        border: 1px solid #E0E0E0;

        img {
          width: 284px;
          height: 276px;
          margin: 140px 0 40px 0;
        }

        p {
          height: 22px;
          font-size: 16px;
          font-weight: 400;
          color: #354052;
          line-height: 22px;
        }
      }
    }

    .box2 {
      padding-top: 20px;

      .jobsInfoBox {
        background: #FFFFFF;
        padding-bottom: 30px;

        .title {
          height: 40px;
          font-size: 14px;
          font-weight: 600;
          color: #333;
          line-height: 40px;
          padding-left: 15px;
          border-bottom: 1px solid #EBEBEB;

          i {
            color: #FF0000;
            margin-right: 5px;
            vertical-align: middle;
          }

          span {
            margin-left: 25px;
            font-size: 12px;
            font-weight: 400;
            color: #2026CC;
            cursor: pointer;
          }
        }

        .addInfo {
          width: 744px;
          height: 104px;
          background: #F5F5F5;
          border: 1px solid #DDDDDD;
          margin: 30px 0 0 15px;
          cursor: pointer;
          text-align: center;

          img {
            width: 40px;
            height: 30px;
            margin: 24px 0 10px 0;
          }

          p {
            height: 17px;
            font-size: 12px;
            font-weight: 400;
            color: #333333;
            line-height: 17px;
          }
        }

        .info {
          width: 704px;
          font-size: 12px;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
          margin-left: 25px;
        }
      }

      .jobsImgsBox {
        background: #FFFFFF;
        margin: 10px 0;

        .imgTitle {
          height: 40px;
          font-size: 14px;
          font-weight: 600;
          color: #333;
          line-height: 40px;
          padding-left: 15px;
          border-bottom: 1px solid #EBEBEB;

          span {
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            margin-left: 10px;
          }
        }

        .imgBox {
          padding: 30px 15px;

          .deteImgBox {
            width: 240px;
            height: 135px;
            position: relative;
            float: left;
            margin-right: 10px;
            margin-bottom: 10px;

            .imgBa {
              width: 100%;
              height: 100%;
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              z-index: 1;
            }

            span {
              position: absolute;
              right: 5px;
              top: 5px;
              height: 17px;
              font-size: 12px;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 17px;
              cursor: pointer;
              z-index: 3;
            }

            .backG {
              width: 100%;
              height: 100%;
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              z-index: 2;
              background: rgba(0, 0, 0, 0.5);
            }
          }

          .addImg {
            float: left;
            width: 238px;
            height: 133px;
            text-align: center;
            border: 1px solid #979797;
            cursor: pointer;
            background: #F5F5F5;

            img {
              width: 34px;
              height: 28px;
              margin-top: 27px;
            }

            .title1 {
              height: 17px;
              font-size: 12px;
              font-weight: 400;
              color: #333333;
              line-height: 17px;
              margin: 10px 0;
            }

            .title2 {
              height: 17px;
              font-size: 12px;
              font-weight: 400;
              color: #999999;
              line-height: 17px;
            }
          }
        }
      }

      .anliBox {
        background: #FFFFFF;

        .anli {
          height: 40px;
          font-size: 14px;
          font-weight: 600;
          color: #333;
          line-height: 40px;
          padding-left: 15px;
          border-bottom: 1px solid #EBEBEB;

          span {
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            margin-left: 15px;
          }

          i {
            margin-left: 10px;
            font-size: 12px;
            font-weight: 400;
            color: #2026CC;
            cursor: pointer;
          }
        }

        .addAnli {
          width: 238px;
          height: 133px;
          text-align: center;
          border: 1px solid #979797;
          cursor: pointer;
          background: #F5F5F5;
          margin: 30px 0 0 15px;

          .title1 {
            height: 17px;
            font-size: 12px;
            font-weight: 400;
            color: #333333;
            line-height: 17px;
          }

          img {
            width: 33px;
            height: 28px;
            margin: 40px 0 10px 0;
          }
        }

        .videoBox {
          margin: 30px 0 0 15px;

          .infoBox {
            width: 255px;
            float: left;
            margin-right: 13px;
            cursor: pointer;

            &:nth-child(3) {
              margin-right: 0;
            }

            .imgBox1 {
              width: 255px;
              height: 144px;
              position: relative;

              .img1 {
                width: 100%;
                height: 100%;
              }

              .img2 {
                width: 33px;
                height: 44px;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
              }
            }

            .name {
              height: 34px;
              font-size: 12px;
              font-weight: 400;
              color: #333333;
              line-height: 17px;
              margin-top: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }

        .textTitle {
          margin-top: 30px;
          // border-top: 1px solid #EBEBEB;
          height: 36px;
          line-height: 36px;
          padding-left: 15px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
        }
      }
    }

    .box3 {
      margin-top: 48px;

      .formBox {
        width: 100%;
        height: 792px;
        box-sizing: border-box;
        background: #FFFFFF;
        border: 1px solid #E0E0E0;

        .tab {
          height: 40px;
          line-height: 40px;
          background: #F5F5F5;
          font-size: 13px;
          font-weight: 400;
          color: #999999;

          .tab1 {
            float: left;
            width: 120px;
            text-align: center;
          }

          .tab2 {
            float: left;
            width: 120px;
            text-align: center;
          }

          .tab3 {
            float: left;
            width: 166px;
            text-align: center;
          }

          .tab4 {
            float: left;
            width: 120px;
            text-align: center;
          }

          .tab5 {
            float: left;
            width: 120px;
            text-align: center;
          }

          .tab6 {
            float: left;
            width: 175px;
            text-align: center;
          }
        }

        .listBox {
          height: 415px;
          margin-bottom: 165px;

          .list {
            height: 58px;
            line-height: 58px;
            border-top: 1px solid #EBEBEB;

            .tab1 {
              float: left;
              width: 100px;
              padding-left: 20px;
              font-size: 13px;
              font-weight: 600;
              color: #333333;
            }

            .tab2 {
              float: left;
              width: 120px;
              text-align: center;
              font-size: 12px;
              font-weight: 400;
              color: #999999;
            }

            .tab3 {
              float: left;
              width: 166px;
              text-align: center;
              font-size: 12px;
              font-weight: 400;
              color: #999999;
            }

            .tab4 {
              float: left;
              width: 120px;
              text-align: center;
              font-size: 12px;
              font-weight: 400;
              color: #22B600;
            }

            .tab5 {
              float: left;
              width: 120px;
              text-align: center;
              font-size: 12px;
              font-weight: 400;
              color: #999999;
            }

            .tab6 {
              float: left;
              width: 175px;
              text-align: center;
              font-size: 12px;
              font-weight: 400;
              color: #999999;
            }
          }
        }
      }

      .noData {
        text-align: center;
        width: 100%;
        height: 792px;
        box-sizing: border-box;
        background: #FFFFFF;
        border: 1px solid #E0E0E0;

        img {
          width: 284px;
          height: 276px;
          margin: 140px 0 40px 0;
        }

        p {
          height: 22px;
          font-size: 16px;
          font-weight: 400;
          color: #354052;
          line-height: 22px;
        }
      }
    }
  }

  .popBox {
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 111;

    .box {
      width: 760px;
      padding-bottom: 50px;
      background: #fff;
      position: absolute;
      left: 50%;
      top: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);

      .title {
        text-align: center;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #e0e0e0;
        font-size: 18px;
        font-weight: 600;
        color: #333;
        position: relative;

        span {
          position: absolute;
          color: #999;
          right: 24px;
          top: 25px;
          width: 13px;
          height: 13px;
          cursor: pointer;
          background: url('/static/uploadvideo/close_btn@2x.png') no-repeat;
          background-size: 100% 100%;
        }
      }

      .info {
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
        margin: 44px 0 54px 0;
        padding: 0 102px;
        text-align: center;
      }

      .info1 {
        margin-bottom: 10px;
      }

      .but {
        text-align: center;

        span {
          padding: 0 35px;
          height: 40px;
          background: #2026CC;
          font-size: 16px;
          font-weight: 600;
          color: #FFFFFF;
          text-align: center;
          line-height: 40px;
          cursor: pointer;
          display: inline-block;
        }
      }

      .but1 {
        text-align: center;

        span {
          padding: 0 35px;
          height: 40px;
          font-size: 16px;
          font-weight: 600;
          text-align: center;
          line-height: 40px;
          cursor: pointer;
          display: inline-block;
          margin-right: 15px;
        }

        span.span1 {
          border: 1px solid #2026CC;
          color: #2026CC;
        }

        span.span2 {
          background: #2026CC;
          color: #FFFFFF;
        }
      }
    }

    .box1 {
      padding-bottom: 23px;
    }

    .box2 {
      width: 760px;
      padding-bottom: 30px;
      background: #fff;
      position: absolute;
      left: 50%;
      top: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      overflow: hidden;

      .title {
        text-align: center;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #e0e0e0;
        font-size: 18px;
        font-weight: 600;
        color: #333;
        position: relative;

        i {
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          margin-left: 10px;
        }

        span {
          position: absolute;
          color: #999;
          right: 24px;
          top: 25px;
          width: 13px;
          height: 13px;
          cursor: pointer;
          background: url('/static/uploadvideo/close_btn@2x.png') no-repeat;
          background-size: 100% 100%;
        }
      }

      .typeBox1 {
        margin: 18px 0 26px 0;
        text-align: center;

        span {
          height: 20px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
          display: inline-block;
          margin-right: 30px;
          cursor: pointer;
        }

        span.active {
          font-weight: 600;
          color: #2026CC;
          border-bottom: 1px solid #2026CC;
        }
      }

      .videoBox {
        padding: 0 15px;
        max-height: 436px;
        overflow-y: scroll;
        margin-bottom: 30px;
        margin-right: -17px;

        .video {
          width: 230px;
          float: left;
          margin-right: 20px;
          margin-bottom: 20px;

          &:nth-child(3n) {
            margin-right: 0;
          }

          .imgBox {
            width: 230px;
            position: relative;

            .img1 {
              width: 230px;
              height: 129px;
            }

            .img2 {
              width: 17px;
              height: 18px;
              position: absolute;
              border-radius: 50%;
              top: 8px;
              right: 8px;
              cursor: pointer;
              z-index: 2;
            }

            span {
              position: absolute;
              font-size: 12px;
              font-weight: 400;
              color: #FFFFFF;
              left: 8px;
              top: 8px;
              z-index: 2;
            }

            i {
              position: absolute;
              width: 17px;
              height: 17px;
              border: 1px solid #FFFFFF;
              border-radius: 50%;
              top: 8px;
              right: 8px;
              color: #fff;
              cursor: pointer;
              z-index: 2;
            }

            .bg {
              width: 230px;
              height: 129px;
              position: absolute;
              left: 0;
              top: 0;
              background: rgba(0, 0, 0, 0.3);
              z-index: 1;
            }
          }

          .videoTitle {
            margin-top: 5px;
            height: 34px;
            font-size: 12px;
            font-weight: 400;
            color: #333333;
            line-height: 17px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            word-break: break-word;
          }
        }

        .noData1 {
          text-align: center;

          p {
            margin: 30px 0 40px 0;
            font-size: 16px;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
          }

          .but {
            width: 117px;
            height: 40px;
            background: #2026CC;
            margin: 0 auto;
            font-size: 16px;
            font-weight: 600;
            color: #FFFFFF;
            cursor: pointer;
            line-height: 40px;
          }
        }
      }

      .photoBox {
        margin-bottom: 60px;

        .photTitle {
          height: 17px;
          font-size: 12px;
          font-weight: 400;
          color: #FF0000;
          line-height: 17px;
          padding-left: 24px;
          margin-bottom: 10px;
        }

        .photoBox1 {
          padding: 0 15px;

          .photo {
            float: left;
            margin-right: 20px;

            &:nth-child(3n) {
              margin-right: 0;
            }

            .imgBox {
              position: relative;
              width: 230px;
              height: 129px;
              margin-bottom: 10px;

              .img1 {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                z-index: 1;
                width: 100%;
                height: 100%;
              }

              .img2 {
                position: absolute;
                font-size: 12px;
                font-weight: 400;
                color: #FFFFFF;
                top: 6px;
                right: 7px;
                z-index: 3;
                cursor: pointer;
                width: 18px;
                height: 18px;
              }

              .backG {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                z-index: 2;
                background: rgba(0, 0, 0, 0.5);
              }
            }

            .photTitle1 {
              width: 230px;
              height: 52px;
            }
          }

          .upImg {
            float: left;
            width: 230px;
            height: 129px;
            border: 1px solid #979797;
            box-sizing: border-box;
            text-align: center;
            background: #F5F5F5;
            cursor: pointer;

            img {
              width: 34px;
              height: 28px;
              margin: 24px 0 10px 0;
            }

            .title1 {
              height: 17px;
              font-size: 12px;
              font-weight: 400;
              color: #333333;
              line-height: 17px;
            }

            .title2 {
              height: 17px;
              font-size: 12px;
              font-weight: 400;
              color: #999999;
              line-height: 17px;
              margin-top: 10px;
            }

            &:nth-child(3n) {
              margin-right: 0;
            }
          }
        }
      }

      .but {
        text-align: center;

        span {
          padding: 0 35px;
          height: 40px;
          background: #2026CC;
          font-size: 16px;
          font-weight: 600;
          color: #FFFFFF;
          text-align: center;
          line-height: 40px;
          cursor: pointer;
          display: inline-block;
        }
      }
    }
  }
}

.upInputIMG, .upInputIMG1 {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/my/account/MyRecruit.vue